import dayjs from 'dayjs';

const REQUIRED_ENV = [
  'VITE_ENVIRONMENT',
  'VITE_FRONT_URL',
  'VITE_GRAPHQL_URI',
  'VITE_CUSTOM_SERVER_URL',
  'VITE_AUTH0_DOMAIN',
  'VITE_AUTH0_CLIENT_ID',
  'VITE_AUTH0_REDIRECT_URI',
  'VITE_BUCKET_BASE_URL',
  'VITE_GOOGLE_MAPS_API_KEY',
  'VITE_GOOGLE_MAPS_MAP_ID',
  'VITE_FRONT_VERSION',
];

const unsetEnvs = REQUIRED_ENV.reduce((unsetEnvAcc, envString) => {
  if (!import.meta.env[envString]) {
    return [...unsetEnvAcc, envString];
  }
  return unsetEnvAcc;
}, [] as string[]);

if (unsetEnvs.length > 0) {
  throw new Error(`Unset env: ${unsetEnvs}`);
}

const maintenanceDate = dayjs(import.meta.env.VITE_FF_MAINTENANCE_DATE);

const config = {
  env: import.meta.env.VITE_ENVIRONMENT,
  auth0: {
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientID: import.meta.env.VITE_AUTH0_CLIENT_ID,
    redirectUri: import.meta.env.VITE_AUTH0_REDIRECT_URI,
    audience: `https://${import.meta.env.VITE_AUTH0_DOMAIN}/api/v2/`,
  },
  hasura: {
    graphqlUri: import.meta.env.VITE_GRAPHQL_URI,
  },
  customServer: {
    baseUrl: import.meta.env.VITE_CUSTOM_SERVER_URL,
  },
  gcp: {
    publicUri: import.meta.env.VITE_BUCKET_BASE_URL,
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
  },
  features: {
    maintenanceDate: maintenanceDate.isValid()
      ? (import.meta.env.VITE_FF_MAINTENANCE_DATE as string)
      : null,
  },
  maps: {
    apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    mapId: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID,
  },
  version: import.meta.env.VITE_FRONT_VERSION,
} as const;

export default config;
